"use client";
// РУКА 2. Панель фильтров раздела. Какие фильтры и в каком порядке — решает магазин в админке
// (ruka3.getFilters), витрина только показывает. Выбор хранится в адресе (?Бренд=GIDROX):
// ссылкой можно поделиться, «Назад» работает. Подписи — из макета.
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useTransition } from "react";

export type FacetGroup = { attr: string; label: string; values: { value: string; count: number }[] };

export function FilterPanel({ groups }: { groups: FacetGroup[] }) {
  const router = useRouter();
  const pathname = usePathname();
  const sp = useSearchParams();
  const [pending, start] = useTransition();

  const go = (next: URLSearchParams) => {
    const q = next.toString();
    start(() => router.replace(q ? `${pathname}?${q}` : pathname, { scroll: false }));
  };
  const toggle = (attr: string, value: string) => {
    const next = new URLSearchParams(sp.toString());
    const cur = next.getAll(attr);
    next.delete(attr);
    for (const v of cur.includes(value) ? cur.filter((x) => x !== value) : [...cur, value]) next.append(attr, v);
    go(next);
  };
  const reset = () => {
    const next = new URLSearchParams(sp.toString());
    for (const g of groups) next.delete(g.attr);
    go(next);
  };
  const anyOn = groups.some((g) => sp.getAll(g.attr).length > 0);

  return (
    <div className={pending ? "opacity-60 transition-opacity" : "transition-opacity"}>
      {groups.map((g) => (
        <fieldset key={g.attr} className="mb-5 last:mb-0">
          <legend className="font-semibold text-sm mb-2">{g.label}</legend>
          <ul className="space-y-1.5">
            {g.values.map((v) => {
              const on = sp.getAll(g.attr).includes(v.value);
              return (
                <li key={v.value}>
                  <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
                    <input
                      type="checkbox"
                      checked={on}
                      aria-label={`${g.label}: ${v.value}`}
                      onChange={() => toggle(g.attr, v.value)}
                      className="w-4 h-4 accent-btn"
                    />
                    <span className="flex-1">{v.value}</span>
                    <span className="text-mute text-xs tabular-nums">{v.count}</span>
                  </label>
                </li>
              );
            })}
          </ul>
        </fieldset>
      ))}
      {anyOn ? (
        <button type="button" onClick={reset} className="mt-4 text-aq-d text-sm font-semibold hover:underline">
          Сбросить фильтры
        </button>
      ) : null}
    </div>
  );
}
